module.exports = __webpack_public_path__ + "static/tirza-van-dijk-72373-unsplash-035b03a37bff72fea292f5987eae28f2.jpg";